import Navbar from "@/components/site/Navbar";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function ServicesPage() {
  return (
    <main className="bg-[#050505]" data-testid="services-page">
      <Navbar />
      <div className="pt-24 md:pt-28">
        <Services />
      </div>
      <Stats />
      <EditorialMarquee />
      <QuoteForm />
      <Footer />
    </main>
  );
}
